export default "__VITE_ASSET__rxj7Lite__"